exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1c8TReE0tGo7rIHTDKGdIv{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;min-width:0}._3MkDoaOdtmX3b9oJUccB2N{overflow-y:auto;overflow-x:hidden;-webkit-box-ordinal-group:3;-ms-flex-order:2;order:2;-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;position:relative}", ""]);
// Exports
exports.locals = {
	"mailListShimmerStateContainer": "_1c8TReE0tGo7rIHTDKGdIv",
	"outerScrollContainer": "_3MkDoaOdtmX3b9oJUccB2N"
};